import React from 'react';
import {
  FormPageAdditionalContent,
  FormPageAdditionalContentProps,
} from '../FormPageAdditionalContent';

export interface SettingsPageAdditionalContentProps
  extends FormPageAdditionalContentProps {}

export function SettingsPageAdditionalContent(
  props: SettingsPageAdditionalContentProps,
) {
  return <FormPageAdditionalContent {...props} />;
}

SettingsPageAdditionalContent.displayName = 'SettingsPageAdditionalContent';
